export default {
  methods: {
    clearMembersStore() {
      if (this.$route.name === 'members') {
        return;
      }

      this.$store.dispatch('members/clear');
      this.$store.dispatch('visitors/clear');
      this.$store.dispatch('topChoices/clear');
    }
  },
};

// export default HandleClearMembersStore;
